<template>
    <TransitionRoot as="template" :show="true">
    <Dialog as="div" class="fixed inset-0 overflow-hidden z-50" @close="clickOff">
        <div class="absolute inset-0 overflow-hidden">
            <TransitionChild as="template" enter="ease-in-out duration-500" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in-out duration-500" leave-from="opacity-100" leave-to="opacity-0">
                <DialogOverlay class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-500 sm:duration-700" leave-from="translate-x-0" leave-to="translate-x-full">
                    <div class="pointer-events-auto w-screen max-w-2xl">
                        <div class="flex h-full flex-col overflow-y-scroll bg-gray-100 py-6 shadow-xl">
                            <div class="px-4 sm:px-6">
                                <div class="flex items-start justify-between">
                                    <DialogTitle class="text-2xl tracking-widest uppercase font-bold text-gray-700">New Sale</DialogTitle>
                                    <div class="ml-3 flex h-7 items-center">
                                        <button type="button" class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" @click="goBack">
                                            <span class="sr-only">Close panel</span>
                                            <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="relative mt-6 flex-1 px-4 sm:px-6">
                                <div class="space-y-6">
                                    <Customer :customer="customer" />
                                    <SaleType :type="type" :product="product" @update="updateType" />
                                    <Product :product="product" :type="type" />
                                    <Discounts :product="product" />
                                    <Purchase :purchase="purchase" />
                                </div>
                            </div>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </div>
    </Dialog>
    </TransitionRoot>
</template>

<script>
import {inject, ref} from 'vue'
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import {useRouter} from "vue-router"
import Customer from "./Partials/Customer"
import SaleType from "./Partials/SaleType";
import Product from "./Partials/Product"
import Discounts from "./Partials/Discounts"
import Purchase from "./Partials/Purchase"

export default {
    components: {
        Customer,
        SaleType,
        Product,
        Discounts,
        Purchase,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        XMarkIcon,
    },
    setup() {
        const alert = inject('alert')
        const customer = ref({})
        const type = ref({})
        const product = ref({})
        const purchase = ref({
            customer: customer,
            product: product,
            type: type,
        })

        const router = useRouter()

        const updateType = (newType) => {
            type.value = newType
        }

        const goBack = () => {
            if (Object.keys(customer.value).length === 0 || purchase.value?.saved === true) {
                router.go(-1)
            } else {
                alert.fire({
                    title: 'Abandon the sale?',
                    text: 'Closing this window will not save your changes, are you sure you wish to close it?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, continue',
                    cancelButtonText: 'No, go back'
                })
                    .then((selected) => {
                        if (selected.value) {
                            router.go(-1)
                        }
                    })
            }
        }

        const clickOff = () => {
            if (Object.keys(customer.value).length === 0) {
                goBack()
            }
        }

        return {
            clickOff,
            goBack,
            customer,
            type,
            product,
            purchase,
            updateType,
        }
    }
}
</script>
